import { get, post } from './http-calls';

export const getJobUserAssigned = async (HeaderRecordId) => {
    let res = await get(`JobUserAssigned?HeaderRecordId=${HeaderRecordId}`, { useAuthToken: true });
    return res;
};

export let uploadJobUserAssigned = async (formData) => {
    let data = await post(`JobUserAssigned`, formData, { useAuthToken: true });
    return data;
};

export const getWorkflowJobs = async (workflowId) => {
    let res = await get(`WorkflowJobs/${workflowId}`, { useAuthToken: true });
    return res;
};

export const getJobLabourLines = async (HeaderRecordID) => {
    let res = await get(`WorkflowJobs/GetJobLabourLines?HeaderRecordID=${HeaderRecordID}`, { useAuthToken: true });
    return res;
};

export const getWorkflowDashBoard = async (workflowId) => {
    let res = await get(`DashBoard/Internal/${workflowId}`, { useAuthToken: true });
    return res;
};
export const getWorkflowDashBoardInternalScreenDropdown = async (workflowId) => {
    let res = await get(`Dashboard/InternalScreenDropdown`, { useAuthToken: true });
    return res;
};

export const getJobBookingsByBranch_Month_Year = async (branchId, month, year, customerName = '') => {
    let res = await get(
        `WorkflowJobs/GetJobBookingsByBranch_Month_Year?CustomerName=${encodeURIComponent(customerName || '')}&BranchID=${branchId || ''}&Month=${month || ''}&Year=${year || ''}`,
        { useAuthToken: true }
    );
    return res;
};
